module.exports = __webpack_public_path__ + "media/svg-new/cronometro-114cc95a.svg";